// extracted by mini-css-extract-plugin
export default {"container":"Popover_container__44kez","square":"Popover_square__tN3tK"};